import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';

import { DumbFilterComponent } from './dumb-filter/dumb-filter.component';
import { DumbFiltersError } from './dumb-filters.errors';
import {
  IDumbFilter,
  IEventDumbFilterEdit,
  IEventDumbFilterRemove,
} from './dumb-filters.types';

@Component({
  selector: 'lum-dumb-filters',
  templateUrl: './dumb-filters.component.html',
  styleUrls: ['./dumb-filters.component.scss'],
  standalone: true,
  imports: [CommonModule, DumbFilterComponent, MatDividerModule],
})
export class DumbFiltersComponent<F extends IDumbFilter = IDumbFilter>
  implements OnInit
{
  @Input() activeFilters! :F[];

  @Output() add = new EventEmitter<void>();
  @Output() clear = new EventEmitter<void>();
  @Output() edit = new EventEmitter<IEventDumbFilterEdit>();
  @Output() remove = new EventEmitter<IEventDumbFilterRemove>();

  ngOnInit() {
    if (!Array.isArray(this.activeFilters)) {
      throw new DumbFiltersError(`'activeFilters' attribute is required`);
    }
  }

  handleAddFilter(e :PointerEvent) {
    e.preventDefault();

    this.add.emit();
  }
  handleClearFilters(e :PointerEvent) {
    e.preventDefault();

    this.clear.emit();
  }

  handleFilterEdit(e :IEventDumbFilterEdit) {
    this.edit.emit(e);
  }
  handleFilterRemove(e :IEventDumbFilterRemove) {
    this.remove.emit(e);
  }
}
